import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import TechnicalKnowledgeAcquiredServices from "./TechnicalKnowledgeAcquired.services";
import GeneralInfoServices from "../GeneralInfo/GeneralInfo.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getTechnicalKnowledgeAcquired = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_TECNICAL_KNOWLEDGE_ACQUIRED,
      payload: true,
    });
    const resp = await TechnicalKnowledgeAcquiredServices.getTechnicalKnowledgeAcquired(filters);
    dispatch({
      type: actions.GET_TECNICAL_KNOWLEDGE_ACQUIRED,
      payload: {
        technicalKnowledgeAcquireds: resp.data.data,
        technicalKnowledgeAcquiredsLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.TECNICAL_KNOWLEDGE_ACQUIRED_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TECNICAL_KNOWLEDGE_ACQUIRED_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TECNICAL_KNOWLEDGE_ACQUIRED,
      payload: false,
    });
  }
};

export const resetGeneralInfo = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_TECNICAL_KNOWLEDGE_ACQUIRED,
      payload: true,
    });
    dispatch({
      type: actions.GET_TECNICAL_KNOWLEDGE_ACQUIRED,
      payload: {
        technicalKnowledgeAcquireds: [],
        technicalKnowledgeAcquiredsLength: 0,
      },
    });
    dispatch({
      type: actions.TECNICAL_KNOWLEDGE_ACQUIRED_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TECNICAL_KNOWLEDGE_ACQUIRED_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TECNICAL_KNOWLEDGE_ACQUIRED,
      payload: false,
    });
  }
};

export const getTechnicalKnowledgeAcquiredById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_TECNICAL_KNOWLEDGE_ACQUIRED_BY_ID,
      payload: true,
    });
    const resp = await TechnicalKnowledgeAcquiredServices.getTechnicalKnowledgeAcquiredById(id);
    dispatch({
      type: actions.GET_TECNICAL_KNOWLEDGE_ACQUIRED_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.TECNICAL_KNOWLEDGE_ACQUIRED_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TECNICAL_KNOWLEDGE_ACQUIRED_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TECNICAL_KNOWLEDGE_ACQUIRED_BY_ID,
      payload: false,
    });
  }
};

export const saveTechnicalKnowledgeAcquired = (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_TECNICAL_KNOWLEDGE_ACQUIRED,
        payload: true,
      });
      const resp = await TechnicalKnowledgeAcquiredServices.saveTechnicalKnowledgeAcquired(data);
      const { technicalKnowledgeAcquireds, technicalKnowledgeAcquiredsLength } = getState().technicalKnowledgeAcquired;
      const _technicalKnowledgeAcquired = [...technicalKnowledgeAcquireds, resp.data];
      dispatch({
        type: actions.GET_TECNICAL_KNOWLEDGE_ACQUIRED,
        payload: {
          technicalKnowledgeAcquireds: _technicalKnowledgeAcquired,
          technicalKnowledgeAcquiredsLength: technicalKnowledgeAcquiredsLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL_TECNICAL_KNOWLEDGE_ACQUIRED,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_TECNICAL_KNOWLEDGE_ACQUIRED,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_TECNICAL_KNOWLEDGE_ACQUIRED,
        payload: false,
      });
    }
  };

export const editTechnicalKnowledgeAcquired = (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_TECNICAL_KNOWLEDGE_ACQUIRED,
        payload: true,
      });
      const resp = await TechnicalKnowledgeAcquiredServices.editTechnicalKnowledgeAcquired(id, data);
      const { technicalKnowledgeAcquireds, technicalKnowledgeAcquiredsLength } = getState().technicalKnowledgeAcquired;
      const dataT = resp.data;
      technicalKnowledgeAcquireds[index] = dataT;
      dispatch({
        type: actions.GET_TECNICAL_KNOWLEDGE_ACQUIRED,
        payload: {
          technicalKnowledgeAcquireds: technicalKnowledgeAcquireds,
          technicalKnowledgeAcquiredsLength: technicalKnowledgeAcquiredsLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL_TECNICAL_KNOWLEDGE_ACQUIRED,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      const _data = {
        data:[
          {
            funcion_descriptor:dataT.list_descriptor[0].posicion,
            tipo_mensaje:"Jefe actualiza descriptor"
          }
        ]
      }
      await GeneralInfoServices.mailSendGeneralInfo(_data);
      toastr.success(messages.correoEnviado, '', {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_TECNICAL_KNOWLEDGE_ACQUIRED,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_TECNICAL_KNOWLEDGE_ACQUIRED,
        payload: false,
      });
    }
  };

export const editIndispensableTechnicalKnowledgeAcquired = (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      // dispatch({
      //   type: actions.LOADING_TECNICAL_KNOWLEDGE_ACQUIRED,
      //   payload: true,
      // });
      const resp = await TechnicalKnowledgeAcquiredServices.editTechnicalKnowledgeAcquired(id, data);
      const { technicalKnowledgeAcquireds, technicalKnowledgeAcquiredsLength } = getState().technicalKnowledgeAcquired;
      const dataT = resp.data;
      technicalKnowledgeAcquireds[index] = dataT;
      dispatch({
        type: actions.GET_TECNICAL_KNOWLEDGE_ACQUIRED,
        payload: {
          technicalKnowledgeAcquireds: technicalKnowledgeAcquireds,
          technicalKnowledgeAcquiredsLength: technicalKnowledgeAcquiredsLength,
        },
      });
      // dispatch({
      //   type: actions.FORM_FAIL_TECNICAL_KNOWLEDGE_ACQUIRED,
      //   payload: "",
      // });
      // setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      const _data = {
        data:[
          {
            funcion_descriptor:dataT.list_descriptor[0].posicion,
            tipo_mensaje:"Jefe actualiza descriptor"
          }
        ]
      }
      await GeneralInfoServices.mailSendGeneralInfo(_data);
      toastr.success(messages.correoEnviado, '', {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      // dispatch({
      //   type: actions.FORM_FAIL_TECNICAL_KNOWLEDGE_ACQUIRED,
      //   payload: message,
      // });
    } finally {
      // dispatch({
      //   type: actions.LOADING_TECNICAL_KNOWLEDGE_ACQUIRED,
      //   payload: false,
      // });
    }
  };

  export const editTechnicalKnowledgeAcquiredById = (data, id, setValidated) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_TECNICAL_KNOWLEDGE_ACQUIRED_BY_ID,
        payload: true,
      });
      const resp = await TechnicalKnowledgeAcquiredServices.editTechnicalKnowledgeAcquired(id, data);
      const dataT = resp.data;
      dispatch({
        type: actions.GET_TECNICAL_KNOWLEDGE_ACQUIRED_BY_ID,
        payload: dataT,
      });
      // const { technicalKnowledgeAcquireds, technicalKnowledgeAcquiredsLength } = getState().technicalKnowledgeAcquired;
      // technicalKnowledgeAcquireds[index] = resp.data;
      // dispatch({
      //   type: actions.GET_TECNICAL_KNOWLEDGE_ACQUIRED,
      //   payload: {
      //     technicalKnowledgeAcquireds: technicalKnowledgeAcquireds,
      //     technicalKnowledgeAcquiredsLength: technicalKnowledgeAcquiredsLength,
      //   },
      // });
      setValidated(false)
      dispatch({
        type: actions.FORM_FAIL_TECNICAL_KNOWLEDGE_ACQUIRED,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      const _data = {
        data:[
          {
            funcion_descriptor:dataT.list_descriptor[0].posicion,
            tipo_mensaje:"Jefe actualiza descriptor"
          }
        ]
      }
      await GeneralInfoServices.mailSendGeneralInfo(_data);
      toastr.success(messages.correoEnviado, '', {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_TECNICAL_KNOWLEDGE_ACQUIRED,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_TECNICAL_KNOWLEDGE_ACQUIRED_BY_ID,
        payload: false,
      });
    }
  };

export const deleteTechnicalKnowledgeAcquired = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_TECNICAL_KNOWLEDGE_ACQUIRED,
      payload: true,
    });
    await TechnicalKnowledgeAcquiredServices.deleteTechnicalKnowledgeAcquired(id);
    const { technicalKnowledgeAcquireds, technicalKnowledgeAcquiredsLength } = getState().technicalKnowledgeAcquired;
    technicalKnowledgeAcquireds.splice(index, 1);
    dispatch({
      type: actions.GET_TECNICAL_KNOWLEDGE_ACQUIRED,
      payload: {
        technicalKnowledgeAcquireds: technicalKnowledgeAcquireds,
        technicalKnowledgeAcquiredsLength: technicalKnowledgeAcquiredsLength - 1,
      },
    });
    dispatch({
      type: actions.TECNICAL_KNOWLEDGE_ACQUIRED_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TECNICAL_KNOWLEDGE_ACQUIRED_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TECNICAL_KNOWLEDGE_ACQUIRED,
      payload: false,
    });
  }
};
